import { Component, OnInit } from '@angular/core';

import { faSync } from '@fortawesome/free-solid-svg-icons';
import { TokenService } from 'src/app/core/services/token.service';

@Component({
    selector: 'app-access-denied',
    templateUrl: './access-mail-revalidate.component.html',
    styleUrls: ['./access-mail-revalidate.component.scss'],
})
export class AccessMailRevalidateComponent implements OnInit {
    reloadIcon = faSync;
    constructor(private tokenService: TokenService) {}

    ngOnInit(): void {}

    refreshToken() {
        this.tokenService.refreshToken();
    }
}
